import {
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadString,
} from 'firebase/storage';
import { InputFileType } from '../../../validation/input/inputType';
import { storage } from '../config';

// ファイルが保存されているstorageのURLを取得する
export const getFileUrl = async (file: InputFileType): Promise<string> => {
  const storage = getStorage();

  try {
    const fileRef = ref(storage, file.file_path);
    return await getDownloadURL(fileRef);
  } catch (error) {
    throw new Error('ファイルが取得できませんでした。');
  }
};

// ファイルをstorageにアップロードする
export const postFile = async (
  file: File,
  userId: string,
  inputId: string,
): Promise<{
  fileName: string;
  storagePath: string;
}> => {
  const fileName = `${Date.now()}_${file.name}`;
  const storagePath = `uploads/${userId}/${inputId}/${fileName}`;
  const storageRef = ref(storage, storagePath);

  await uploadBytes(storageRef, file);
  return { fileName, storagePath };
};

export const uploadFile = async (
  fileIcon: FileList | null,
  storagePath: string,
): Promise<{
  storagePath: string;
  iconUrl: string;
}> => {
  if (!fileIcon || fileIcon.length === 0) {
    throw new Error('ファイルが選択されていません');
  }

  const file = fileIcon[0];
  const storageRef = ref(storage, storagePath);

  try {
    // ファイルをアップロード
    await uploadBytes(storageRef, file);
    const iconUrl = await getDownloadURL(storageRef);

    return { storagePath, iconUrl };
  } catch (error) {
    throw new Error('ファイルのアップロードに失敗しました');
  }
};

export const deleteFile = async (storagePath: string): Promise<void> => {
  if (!storagePath) {
    throw new Error('削除するファイルパスが指定されていません');
  }

  const fileRef = ref(storage, storagePath);

  try {
    await deleteObject(fileRef);
  } catch (error) {
    throw new Error('ファイルの削除に失敗しました');
  }
};

export const clientMasterUpdate = async (
  mansionName: string,
  roomNumber = '',
  address = '',
): Promise<number> => {
  const storage = getStorage();
  const path = 'master/顧客マスタ.csv';
  const fileRef = ref(storage, path);

  // CSVを取得
  const url = await getDownloadURL(fileRef);
  const response = await fetch(url);
  const text = await response.text();

  // CSVをパース
  const rows = text
    .split('\n')
    .filter(row => row.trim() !== '')
    .map(row => row.split(','));

  // 最終行のID取得（最終行はヘッダーを含まない前提）
  const lastRow = rows[rows.length - 1];
  const lastId = lastRow ? Number(lastRow[0]) || 0 : 0;
  const newId = lastId + 1;

  // 新規レコード作成
  const newRecord = `${newId},${mansionName},${roomNumber},${address}\n`;
  const updatedCSV = text.endsWith('\n') ? text + newRecord : text + '\n' + newRecord;

  // CSVをストレージにアップロード
  await uploadString(fileRef, updatedCSV);

  return newId;
};

export const productMasterUpdate = async (
  debtorAddress: string,
  mortgageeCompanyName = 0,
): Promise<number> => {
  const storage = getStorage();
  const path = 'master/商品マスタ.csv';
  const fileRef = ref(storage, path);

  // CSV取得
  const url = await getDownloadURL(fileRef);
  const response = await fetch(url);
  const text = await response.text();

  // CSVをパース
  const rows = text
    .split('\n')
    .filter(row => row.trim() !== '')
    .map(row => row.split(','));

  // 最終行のID取得（最終行はヘッダーを含まない前提）
  const lastRow = rows[rows.length - 1];
  const lastId = lastRow ? Number(lastRow[0]) || 0 : 0;
  const newId = lastId + 1;

  // 新規レコード作成
  const newRecord = `${newId},${debtorAddress},${mortgageeCompanyName}\n`;
  const updatedCSV = text.endsWith('\n') ? text + newRecord : text + '\n' + newRecord;

  // CSVをストレージにアップロード
  await uploadString(fileRef, updatedCSV);

  return newId;
};
